/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { IPage } from '../pages';

export default function useHandleNavigation() {
    const nav = useNavigate();

    const navigate = React.useCallback((page: IPage, requestId: string) => {
        const newPath = page.route.path.replace(':requestId', requestId);
        nav(newPath);
    }, []);

    return { navigate };
}
